import { ModalProvider } from "@logora/debate.dialog.modal";
// in src/MyLayout.js
import React from "react";
import { Layout } from "react-admin";
import MyAppBar from "./AppBar";
import { MainError } from "./MainError";
import MyMenu from "./Menu";

const MyLayout = ({ children }) => {
	return (
		<>
			<ModalProvider>
				<Layout
					menu={MyMenu}
					appBar={MyAppBar}
					error={MainError}
					sx={{
						minWidth: 0,
						"& .RaLayout-content": {
							minWidth: 0,
						},
					}}
				>
					{children}
				</Layout>
			</ModalProvider>
		</>
	);
};

export default MyLayout;
